import type { DogProfile } from '../dog/Profile';

/** Collars are earned by care streaks; the best one unlocked is worn. */
export interface CollarTier {
  tier: number;
  name: string;
  streak: number; // best streak needed
  color: (p: DogProfile) => number;
  studs: boolean;
  tag: boolean;
}

export const COLLARS: CollarTier[] = [
  { tier: 0, name: 'no collar', streak: 0, color: () => 0x000000, studs: false, tag: false },
  { tier: 1, name: 'plain collar', streak: 1, color: () => 0x5a5652, studs: false, tag: false },
  { tier: 2, name: 'her own colour', streak: 3, color: (p) => (p.id === 'luna' ? 0x7b5cc4 : 0xe0702a), studs: false, tag: true },
  { tier: 3, name: 'studded collar', streak: 7, color: (p) => (p.id === 'luna' ? 0x5c3f9e : 0xb84e14), studs: true, tag: true },
  { tier: 4, name: 'fancy collar', streak: 14, color: () => 0xd4a63a, studs: true, tag: true },
  { tier: 5, name: 'gold collar', streak: 30, color: () => 0xf2c94c, studs: true, tag: true },
];

export function unlockedCollar(bestStreak: number): CollarTier {
  let best = COLLARS[0];
  for (const c of COLLARS) if (bestStreak >= c.streak) best = c;
  return best;
}

export function nextCollar(bestStreak: number): CollarTier | null {
  return COLLARS.find((c) => c.streak > bestStreak) ?? null;
}
